import script from "./SessionListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionListItem.vue?vue&type=script&setup=true&lang=js"

import "./SessionListItem.vue?vue&type=style&index=0&id=212874f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212874f0"]])

export default __exports__